import { GameState } from '../game/GameState';
import { DataRegistry } from './DataRegistry';

export class ReligionCultureManager {
  static readonly instance = new ReligionCultureManager();

  convertReligion(provinceId: string) {
    const campaign = GameState.instance.requireCampaign();
    const province = campaign.provinces[provinceId];
    const faction = province ? campaign.factions[province.owner] : undefined;
    if (!province || !faction) return false;
    if (faction.treasury < 40) {
      GameState.instance.log('Conversion mission requires 40 gold.', 'warning');
      return false;
    }
    faction.treasury -= 40;
    province.loyalty = Math.max(0, province.loyalty - 3);
    province.unrest = Math.min(100, province.unrest + 3);
    faction.legitimacy = Math.min(100, faction.legitimacy + 1);
    GameState.instance.log(`Clergy sent to ${DataRegistry.instance.provinces[provinceId]?.name}.`, 'success');
    return true;
  }

  integrateCulture(provinceId: string) {
    const campaign = GameState.instance.requireCampaign();
    const province = campaign.provinces[provinceId];
    const faction = province ? campaign.factions[province.owner] : undefined;
    if (!province || !faction) return false;
    if (faction.treasury < 35) {
      GameState.instance.log('Cultural integration requires 35 gold.', 'warning');
      return false;
    }
    faction.treasury -= 35;
    province.loyalty = Math.min(100, province.loyalty + 8);
    province.unrest = Math.max(0, province.unrest - 4);
    GameState.instance.log(`Local elites integrated in ${DataRegistry.instance.provinces[provinceId]?.name}.`, 'success');
    return true;
  }
}
